export default "__VITE_ASSET__CmH3eFY6__"